/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";
import Col from "../../UIcomponent/Column";
import "./Schedule.scss";
import DateTime from "../../Utility/Method/DateTime";
import nextIcon from "../../Assets/icon/nextIcon.png";
import previousIcon from "../../Assets/icon/previousIcon.png";
import Image from "../../UIcomponent/Image";
import StyledButton from "../../UIcomponent/Button";
import { StatusObj } from "./Utility/StatusObj";
import CellGeneator from "./Method/CellGeneator";
import Mapper from "./Method/Mapper";
import WeekGenerator from "./Method/WeekGenerator";
import { WeekStartEnd } from "./Method/WeekStartEnd";
import EventHandler from "./Method/EventHandler";
import { DragModeList } from "./Utility/DragModeList";
import { PersianMonth } from "../../Utility/Method/DateTimeConstant";
import Today from "./Utility/Today";
import moment from "moment-jalaali";
import WarningModal from "./Utility/WarningModal";
const Schedule = (props) => {
  const {
    Calendar,
    timezone,
    Data,
    lang,
    onNextWeek,
    onPreviousWeek,
    loading,
    Loader,
    isSubmiting,
    onSubmit,
  } = props;
  const [DragMode, setDragMode] = useState("add");
  const [DateStatus, setDateStatus] = useState(Data);
  const [weeklyCell, setWeeklyCell] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  let width = window.innerWidth;
  let Refs = [];
  const setRef = (ref) => {
    Refs.push(ref);
  };
  let step = props.duration || 0.5;
  const [firstDay, setFirstDay] = useState(Today.Obj());
  let row = props.row || 6;
  let chunk = 24 / step;
  let monthLength = new Date(
    firstDay.Year,
    firstDay.Month + 1 || 0,
    0
  ).getDate();
  let currentMonth = [
    ...new Set([
      ...weeklyCell.map((each) => {
        return each.date_time.month;
      }),
    ]),
  ];
  let currentMonthYear = [
    ...new Set([
      ...weeklyCell.map((each) => {
        return each.date_time.year;
      }),
    ]),
  ].reverse();
  let allDay = [
    Calendar
      ? CellGeneator.InitialCalendarCell(firstDay, step)
      : CellGeneator.InitialWeeklyCell(step),
  ];
  let Week = [];
  let ColumnArr = [];
  let RowArr = [];

  Calendar
    ? CellGeneator.CalendarGenarator(allDay, firstDay, step)
    : CellGeneator.WeeklyGenerator(allDay, step);
  Calendar
    ? Mapper.Calendar(DateStatus, allDay, firstDay, monthLength, step)
    : Mapper.Weekly(DateStatus, allDay, step);
  Calendar
    ? WeekGenerator.Calendar(allDay, Week, chunk)
    : WeekGenerator.Weekly(allDay, Week, chunk);

  const nextWeekHandler = (callback) => {
    // let StartDay = {
    //     ...firstDay,
    //     Day: firstDay.Day + 7 > monthLength ? (firstDay.Day + 7) - monthLength : firstDay.Day + 7,
    //     Month: firstDay.Day + 7 > monthLength ? firstDay.Month + 1 : firstDay.Month,
    //     Year: firstDay.Day + 7 > monthLength && firstDay.Month + 1 > 11 ? firstDay.Year + 1 : firstDay.Year
    // }
    let nextWeekStartEpoche =
      moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day)) +
      7 * 24 * 60 * 60 * 1000;
    let StartDay = {
      ...firstDay,
      Day: Number(moment(nextWeekStartEpoche).format("D")),
      Month: Number(moment(nextWeekStartEpoche).format("M") - 1),
      Year: Number(moment(nextWeekStartEpoche).format("YYYY")),
    };
    let FromTo = WeekStartEnd(StartDay, "next");
    Refs.forEach((each) => each.classList.remove("o__Schedule__Cell--DragAdd"));
    setFirstDay(StartDay);
    if (callback) {
      callback(FromTo);
    }
  };

  const previousWeekHandler = (callback) => {
    // let monthLength = new Date(firstDay.Year, (firstDay.Month), 0).getDate()
    // let StartDay = {
    //     ...firstDay,
    //     Day: firstDay.Day - 7 <= 0 ? monthLength + firstDay.Day - 7 : firstDay.Day - 7,
    //     Month: firstDay.Day - 7 <= 0 ? firstDay.Month - 1 : firstDay.Month,
    //     Year: firstDay.Day - 7 <= 0 && firstDay.Month - 1 < 0 ? firstDay.Year - 1 : firstDay.Year
    // }
    let nextWeekStartEpoche =
      moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day)) -
      7 * 24 * 60 * 60 * 1000;
    let StartDay = {
      ...firstDay,
      Day: Number(moment(nextWeekStartEpoche).format("D")),
      Month: Number(moment(nextWeekStartEpoche).format("M") - 1),
      Year: Number(moment(nextWeekStartEpoche).format("YYYY")),
    };
    let FromTo = WeekStartEnd(StartDay, "previous");
    setFirstDay(StartDay);
    if (callback) {
      callback(FromTo);
    }
  };

  const updateCalendar = (callback, isConfirmed = false) => {
    if (Calendar) {
      let data = {
        NewSlots: DateStatus.filter(
          (each) =>
            each.ID !== null &&
            each.ID == 0 &&
            each.Status != each.initialStatus
        ).map((each) => {
          return {
            From: each.date_time_from,
            To: each.date_time_to,
            Status: each.Status,
          };
        }),
        DeleteSlots: [
          ...new Set(
            DateStatus.filter(
              (each) =>
                each.ID !== null &&
                each.ID != 0 &&
                each.Status != each.initialStatus
            ).map((each) => each.ID)
          ),
        ],
      };
      let nextWeekStartEpoche =
        moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day)) -
        7 * 24 * 60 * 60 * 1000;
      let StartDay = {
        ...firstDay,
        Day: Number(moment(nextWeekStartEpoche).format("D")),
        Month: Number(moment(nextWeekStartEpoche).format("M") - 1),
        Year: Number(moment(nextWeekStartEpoche).format("YYYY")),
      };
      let FromTo = WeekStartEnd(StartDay, "next");

      const countPeriods = DateStatus.filter((item) => item.Status === 1)
        .map((element) => {
          return (
            Math.abs(
              (new Date(element.date_time_from) -
                new Date(element.date_time_to)) /
                (1000 * 60 * 60)
            ) / 0.5
          );
        })
        .reduce((p, c) => p + c, 0);

      if (countPeriods < 10 && !isConfirmed) {
        return setIsOpen(true);
      } else {
        if (callback) {
          return callback(data, FromTo);
        }
        return undefined;
      }
    } else {
      let Slots = [];
      let countPeriods = DateStatus.map(
        (item) => (item.End - item.Start) / 0.5
      ).reduce((p, c) => p + c, 0);

      DateStatus.forEach((each) => {
        if (each.End > each.Start) {
          if (timezone == "Asia/Tehran") {
            Slots.push({
              Start:
                each.Start - 24 < 0 ? each.Start - 24 + 168 : each.Start - 24,
              End: each.End - 24 < 0 ? each.End - 24 + 168 : each.End - 24,
            });
          } else {
            Slots.push({
              Start: each.Start,
              End: each.End,
            });
          }
        }
      });

      if (countPeriods < 10 && !isConfirmed) {
        return setIsOpen(true);
      } else {
        if (callback) {
          return callback(Slots);
        }

        return undefined;
      }
    }
  };

  const onDragOver = (e, cell, IndexRow, IndexColumn, index) => {
    e.preventDefault();
    EventHandler.DragOver(
      allDay,
      cell,
      IndexRow,
      IndexColumn,
      index,
      ColumnArr,
      RowArr,
      Refs,
      DragMode
    );
  };
  const onDragEnd = () => {
    Calendar
      ? EventHandler.CalendarDragEnd(
          DateStatus,
          setDateStatus,
          allDay,
          firstDay,
          ColumnArr,
          RowArr,
          Refs,
          DragMode,
          step
        )
      : EventHandler.WeeklyDragEnd(
          DateStatus,
          setDateStatus,
          allDay,
          ColumnArr,
          RowArr,
          Refs,
          DragMode
        );
  };
  const DragModeHandler = (mode) => {
    setDragMode(mode);
  };
  const cellSelectHandler = (cell, index) => {
    Calendar
      ? EventHandler.CalendarClick(
          DateStatus,
          setDateStatus,
          allDay,
          firstDay,
          index,
          step,
          DragMode
        )
      : EventHandler.WeeklyClick(
          DateStatus,
          setDateStatus,
          allDay,
          cell,
          index,
          DragMode
        );
  };

  useMemo(() => {
    setDateStatus(Data);
  }, [Data]);

  useLayoutEffect(() => {
    moment.locale("en");
  }, []);

  useEffect(() => {
    setWeeklyCell(Week);
  }, [DateStatus, firstDay]);

  let currentMonthStr = () => {
    let str = "";
    let CurrentMonthArr = [];
    currentMonth.forEach((each, index) => {
      CurrentMonthArr.push(PersianMonth[each - 1]);
    });
    str = `${CurrentMonthArr.join(" - ")}`;
    return <div>{str}</div>;
  };

  let currentYearStr = () => {
    let str = "";
    let CurrentYearArr = [];
    currentMonthYear.forEach((each, index) => {
      if (
        index !== currentMonthYear.length - 1 &&
        currentMonthYear.length > 1
      ) {
        let eachStr = each.toString();
        CurrentYearArr.push(`${eachStr[2] + "" + eachStr[3]}`);
      } else {
        CurrentYearArr.push(each);
      }
    });
    str = `${CurrentYearArr.join(" - ")}`;
    return <div>{str}</div>;
  };

  return (
    weeklyCell.length > 0 && (
      <Col className="l__Schedule" xl={24} lg={24} md={24} sm={24} xs={24}>
        <Col
          className="c__Schedule__Options"
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
        >
          <Col
            xl={14}
            lg={22}
            md={22}
            sm={22}
            xs={22}
            className="c__Schedule__Notif"
          >
            برای تغییر {Calendar ? "زمان های آزاد" : "برنامه هفتگی"} خود می
            توانید ابتدا یکی از حالت های حذف یا اضافه را انتخاب نموده و سپس با
            کشیدن ماوس بر روی خانه ها و یا کلیک بر روی آنها وضعیت زمانبندی را
            تعیین کرده و در انتها برای ثبت تغییرات ، روی دکمه ذخیره کلیک نمایید.
          </Col>
          <Col
            xl={22}
            lg={23}
            md={23}
            sm={23}
            xs={23}
            className="c__Schedule__Action"
          >
            <Col
              xl={4}
              lg={6}
              md={8}
              sm={8}
              xs={8}
              className="c__Schedule__DragController"
            >
              <Col
                xl={11}
                lg={12}
                md={6}
                sm={12}
                xs={12}
                className="o__DragController__DragModes"
              >
                {DragModeList.map((mode) => {
                  return (
                    <Col
                      className="o__DragController__DragMode"
                      onClick={() => DragModeHandler(mode.value)}
                    >
                      <Col className="o__DragController__DragMode--Status">
                        {DragMode === mode.value && <Col></Col>}
                      </Col>
                      <Col className="o__DragController__DragMode--Value">
                        {mode.name}
                      </Col>
                    </Col>
                  );
                })}
              </Col>
              {props.weekly && (
                <Col
                  xl={12}
                  lg={12}
                  md={6}
                  sm={12}
                  xs={12}
                  className="o__DragController__Dropdown"
                >
                  {/* {leftChoise > 0 ?
                                <Col>
                                    {`${DateStatus.filter(each => each.status === 1).length * step} ساعت زمان بندی شده است`}
                                </Col>
                                : 'همه جلسات انتخاب شده اند'} */}
                </Col>
              )}
            </Col>
            <Col
              xl={16}
              lg={12}
              md={8}
              sm={8}
              xs={8}
              className="c__Schedule__WeekController"
            >
              {Calendar && (
                <>
                  <Col
                    className={`${
                      firstDay.Month === Today.Month() &&
                      firstDay.Day - Today.Date() < 7
                        ? "o__WeekController__Button--OFF"
                        : "o__WeekController__Button"
                    }`}
                    onClick={() => previousWeekHandler(onPreviousWeek)}
                  >
                    <Image src={nextIcon} />
                  </Col>
                  <Col
                    // xl={12} lg={12} md={12} sm={12} xs={12}
                    className="o__WeekController__CurrentMonth"
                  >
                    {currentMonthStr()}
                    {currentYearStr()}
                  </Col>

                  <Col
                    className="o__WeekController__Button"
                    onClick={() => nextWeekHandler(onNextWeek)}
                  >
                    <Image src={previousIcon} />
                  </Col>
                </>
              )}
            </Col>
            <Col
              xl={4}
              lg={6}
              md={8}
              sm={8}
              xs={8}
              className="o__Schedule__Btn"
            >
              {/*

                            disable={Calendar && DateStatus.filter(each => each.Status !== each.initialStatus).length > 0 ? false
                                : !Calendar && DateStatus.filter(each => each.isUpdated).length > 0 ? false : true}
                            */}
              <StyledButton
                loading={isSubmiting}
                primary
                onClick={() => updateCalendar(onSubmit)}
              >
                ذخیره
              </StyledButton>
            </Col>
          </Col>
          <Col
            xl={24}
            lg={24}
            md={24}
            sm={24}
            xs={24}
            className="c__Schedule__TopBar"
          >
            <Col
              className="o__Schedule__Day"
              xl={22}
              lg={22}
              md={21}
              sm={21}
              xs={21}
            >
              {weeklyCell.map((day, index) => {
                return (
                  <Col
                    xl={20.5 / 7}
                    lg={20.5 / 7}
                    md={20.5 / 7}
                    sm={20.5 / 7}
                    xs={20.5 / 7}
                    className="o__Schedule__Day__Title"
                    style={{
                      ...props.titleStyle,
                      height: `${props.size}px`,
                    }}
                  >
                    {Calendar ? (
                      <>
                        {width > 992
                          ? DateTime.getDayFullStr(day.day)[`${props.lang}`]
                          : DateTime.getDayShortStr(day.day)[`${props.lang}`]}
                        <br />
                        {day.date_time.day +
                          " " +
                          (width > 992
                            ? PersianMonth[day.date_time.month - 1]
                            : "")}
                      </>
                    ) : width > 992 ? (
                      DateTime.getDayFullStr(day.day)[`${props.lang}`]
                    ) : (
                      DateTime.getDayShortStr(day.day)[`${props.lang}`]
                    )}
                  </Col>
                );
              })}
            </Col>
          </Col>
        </Col>
        {loading === false && (
          <Col className="c__Schedule" xl={24} lg={24} md={24} sm={24} xs={24}>
            <Col
              xl={22}
              lg={22}
              md={21}
              sm={21}
              xs={21}
              className="o__Schedule"
              style={{
                height: props.size * (row + 1) + "px",
              }}
            >
              <Col
                xl={3.5}
                lg={3.5}
                md={4}
                sm={4}
                xs={4}
                className="c__Schedule__Hours"
              >
                <Col
                  className="o__Schedule__Hours"
                  style={{
                    paddingBottom: `${props.size / 2}px`,
                  }}
                >
                  {weeklyCell[0].times.map((hours, index) => {
                    return (
                      index > 0 && (
                        <Col
                          style={{
                            height: `${props.size}px`,
                            marginTop: index === 1 && `${props.size / 2}px`,
                          }}
                          key={hours.Start}
                        >
                          {(hours.startHour < 10
                            ? "0" + hours.startHour
                            : hours.startHour) +
                            ":" +
                            (hours.startMin === 0 ? "00" : hours.startMin)}
                        </Col>
                      )
                    );
                  })}
                </Col>
              </Col>
              <Col
                xl={20.5}
                lg={(24 * 6) / 7}
                md={21}
                sm={21}
                xs={21}
                className="c__Schedule__DayStatus"
              >
                {weeklyCell.map((day, IndexColumn) => {
                  return (
                    <Col
                      xl={24 / 7}
                      lg={24 / 7}
                      md={24 / 7}
                      sm={24 / 7}
                      xs={24 / 7}
                      className="o__Schedule__Day__Column"
                    >
                      {day.times.map((time, IndexRow) => {
                        let INDEX = IndexColumn * 48 + IndexRow;
                        return (
                          <Col
                            draggable={true}
                            // ondragstart={(event) => event.dataTransfer.setData('text/plain', 'This text may be dragged')}
                            className={`${
                              (time.status === StatusObj.BookByOther ||
                                time.status === StatusObj.BookByYou) &&
                              "o__Schedule__Cell--Booked"
                            } o__Schedule__Cell`}
                            height="auto"
                            style={{
                              ...props.dayStyle,
                              backgroundColor:
                                time.status === StatusObj.Available &&
                                "#7dc837",
                              color:
                                time.status === StatusObj.Available && "white",
                              cursor: "pointer",
                              height: `${props.size}px`,
                            }}
                            key={time.Start}
                            innerRef={setRef}
                            onDrop={(e) => e.preventDefault()}
                            onDragOver={(e) =>
                              onDragOver(e, time, IndexRow, IndexColumn, INDEX)
                            }
                            onDragEnd={onDragEnd}
                            onClick={
                              time.status !== StatusObj.BookByOther ||
                              time.status !== StatusObj.BookByOther
                                ? () => cellSelectHandler(time, INDEX)
                                : null
                            }
                          ></Col>
                        );
                      })}
                    </Col>
                  );
                })}
              </Col>
            </Col>
          </Col>
        )}
        {loading === true && (
          <Col className="c__Schedule" xl={24} lg={24} md={24} sm={24} xs={24}>
            <Loader height={150} />
          </Col>
        )}
        <WarningModal
          isOpen={isOpen}
          onConfirm={() => updateCalendar(onSubmit, true)}
          handleClose={() => setIsOpen(false)}
        />
      </Col>
    )
  );
};
export default Schedule;
